/*
 * As frases que mais de uma tela do módulo diz.
 *
 * A convenção do repositório pede que texto de interface fique concentrado num
 * só lugar do componente, e que nenhuma frase seja repetida em dois arquivos —
 * é o que torna mecânica a extração para arquivos de tradução. Estas quatro
 * nasceram duplicadas entre o passo a passo, a tela completa e os cartões, e
 * uma delas já tinha duas redações.
 */
const TEXTOS = {
  ABRIR_NO_SERVICO: 'Abrir no site do serviço',
  NUNCA_TESTADA: 'Nunca testada',
  VALE_DEPOIS_DE_SALVAR: 'As alterações só valem depois de salvar.',
};

export default TEXTOS;
